 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_cover'
 import HTMLEBB from '@/components/html/ebb'
 import HTMLARCHIVE from '@/components/html/archive'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML02_TP from '@/components/html/02_tp'
 import HTML04_TOC from '@/components/html/04_toc'
 import HTML03_DEDI from '@/components/html/03_dedi'
 import HTML05_PRE from '@/components/html/05_pre'
 import HTML06_CHRO from '@/components/html/06_chro'
 import HTML08_EPI from '@/components/html/08_epi'
 import HTML09_C1 from '@/components/html/09_c1'
 import HTML10_C1A from '@/components/html/10_c1a'
 import HTML11_C2 from '@/components/html/11_c2'
 import HTML12_C2A from '@/components/html/12_c2a'
 import HTML13_C3 from '@/components/html/13_c3'
 import HTML14_C3A from '@/components/html/14_c3a'
 import HTML15_C4 from '@/components/html/15_c4'
 import HTML16_C4A from '@/components/html/16_c4a'
 import HTML17_C5 from '@/components/html/17_c5'
 import HTML18_C5A from '@/components/html/18_c5a'
 import HTML19_EPILOGUE from '@/components/html/19_epilogue'
 import HTML20_EPILOGUEA from '@/components/html/20_epiloguea'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML21_ACK from '@/components/html/21_ack'
 import HTML22_MAP from '@/components/html/22_map'
 import HTMLCOPYRIGHT from '@/components/html/Copyright'
 import HTMLORIMAD from '@/components/html/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_toc",
 			"name" : "html/04_toc",
 			"component" : HTML04_TOC
 		},
 		{
 			"path" : "/html/03_dedi",
 			"name" : "html/03_dedi",
 			"component" : HTML03_DEDI
 		},
 		{
 			"path" : "/html/05_pre",
 			"name" : "html/05_pre",
 			"component" : HTML05_PRE
 		},
 		{
 			"path" : "/html/06_chro",
 			"name" : "html/06_chro",
 			"component" : HTML06_CHRO
 		},
 		{
 			"path" : "/html/08_epi",
 			"name" : "html/08_epi",
 			"component" : HTML08_EPI
 		},
 		{
 			"path" : "/html/09_c1",
 			"name" : "html/09_c1",
 			"component" : HTML09_C1
 		},
 		{
 			"path" : "/html/10_c1a",
 			"name" : "html/10_c1a",
 			"component" : HTML10_C1A
 		},
 		{
 			"path" : "/html/11_c2",
 			"name" : "html/11_c2",
 			"component" : HTML11_C2
 		},
 		{
 			"path" : "/html/12_c2a",
 			"name" : "html/12_c2a",
 			"component" : HTML12_C2A
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js